import { WidgetsVariant } from '../hooks/types'

type WidgetConfig = {
  value: boolean
  order: number
}

export const parseWidgetsConfig = (
  widgetsConfig: Record<string, WidgetConfig> | undefined,
  adminOnlyWidgets: string[] | undefined,
  isAdmin: boolean,
): WidgetsVariant[] => {
  if (!widgetsConfig) {
    return []
  }

  const validWidgets = Object.values(WidgetsVariant)
  const adminOnlySet = new Set(adminOnlyWidgets || [])

  return Object.entries(widgetsConfig)
    .filter(([widgetName, config]) => {
      if (!validWidgets.includes(widgetName as WidgetsVariant)) {
        return false
      }

      if (!config.value) {
        return false
      }

      if (adminOnlySet.has(widgetName) && !isAdmin) {
        return false
      }

      return true
    })
    .sort(([, configA], [, configB]) => configA.order - configB.order)
    .map(([widgetName]) => widgetName as WidgetsVariant)
}
